import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

function DashboardLayout(){

      return(
           //mobile first ui have two layouts, one for mobile and one for desktop
            <div className="flex column v-100" style={{ height: "100vh", background: "white"}}>
                  <div className="flex ten min-0">
                        <Outlet/>
                  </div>
                  <div className="flex one">
                        <Navbar/>
                  </div>
            </div>
      )
}

export default DashboardLayout;